import * as betprofessor from './NextToJumpList.styles.betprofessor';
import * as betroyale from './NextToJumpList.styles.betroyale';
import * as fiestabet from './NextToJumpList.styles.fiestabet';
import * as goldenrush from './NextToJumpList.styles.goldenrush';
import * as juicybet from './NextToJumpList.styles.juicybet';
import * as puntcity from './NextToJumpList.styles.puntcity';
import * as puntgenie from './NextToJumpList.styles.puntgenie';
import * as questbet from './NextToJumpList.styles.questbet';
import * as sterlingparker from './NextToJumpList.styles.sterlingparker';
import * as vikingbet from './NextToJumpList.styles.vikingbet';
import * as volcanobet from './NextToJumpList.styles.volcanobet';
import * as forsport from './NextToJumpList.styles.forsport';
import * as junglebet from './NextToJumpList.styles.junglebet';
import * as sugarcastle from './NextToJumpList.styles.sugarcastle';
import * as oldgill from './NextToJumpList.styles.oldgill';
import * as buffalobet from './NextToJumpList.styles.buffalobet';
import * as titanbet from './NextToJumpList.styles.titanbet';
import * as slambet from './NextToJumpList.styles.slambet';
import * as gigabet from './NextToJumpList.styles.gigabet';
import * as betstride from './NextToJumpList.styles.betstride';
import * as templebet from './NextToJumpList.styles.templebet';
import * as goldenbet888 from './NextToJumpList.styles.goldenbet888';
import * as hyperbet from './NextToJumpList.styles.hyperbet';
import * as bet777 from './NextToJumpList.styles.bet777';
import * as chromabet from './NextToJumpList.styles.chromabet';
import * as bet575 from './NextToJumpList.styles.bet575';
import * as betblast from './NextToJumpList.styles.betblast';
import * as pyramidbet from './NextToJumpList.styles.pyramidbet';
import * as magnumbet from './NextToJumpList.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
